import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";

const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";

const getLabel = (intl, id, fallback) => {
  if (!intl || !intl.formatMessage) return fallback;
  const value = intl.formatMessage({ id });
  return value || fallback;
};

export const formatStockExportData = (data = [], intl) => {
  return data.map((item, index) => ({
    [getLabel(intl, "stock.export.stt", "No.")]: index + 1,
    [getLabel(intl, "stock.export.id", "ID")]: item.id,
    [getLabel(intl, "stock.export.name", "Material Name")]: item.name,
    [getLabel(intl, "stock.export.sku", "SKU")]: item.sku,
    [getLabel(intl, "stock.export.unit", "Unit")]: item.unit,
    [getLabel(intl, "stock.export.category", "Category")]: item.category_name,
    [getLabel(intl, "stock.export.warehouse", "Warehouse")]: item.warehouse_name,
    [getLabel(intl, "stock.export.min_stock_threshold", "Min Stock")]:
      item.min_stock_threshold,
    [getLabel(intl, "stock.export.batch_code", "Batch Code")]: item.batch_code,
    [getLabel(intl, "stock.export.storage_location", "Storage Location")]:
      item.storage_location,
    [getLabel(intl, "stock.export.stock_note", "Stock Note")]: item.stock_note,
    [getLabel(intl, "stock.export.price_new", "Price")]: item.price_new,
    // count: "",
    [getLabel(intl, "stock.export.inventory", "Inventory")]: item.count,
    [getLabel(intl, "stock.export.total", "Total Amount")]: item.total,
    [getLabel(intl, "stock.export.created_at", "Created At")]: item.createdAt,
    [getLabel(intl, "stock.export.updated_at", "Updated At")]: item.updatedAt,
  }));
};

export const exportStockToExcel = ({ data = [], intl }) => {
  const fileName = getLabel(intl, "stock.export.filename", "Stock List");
  const csvData = formatStockExportData(data, intl);
  const ws = XLSX.utils.json_to_sheet(csvData);
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(blob, `${fileName}${fileExtension}`);
};
